import React from "react";
import { Lock, ShieldCheck } from "lucide-react";
import { Rich } from "./shared";

// How-to steps for sensitive actions: shown to the roles that can perform them, a short note for everyone else.
export default function SensitiveSteps({ blocks }) {
  if (!blocks?.length) return null;
  return (
    <section id="steps" data-testid="kc-steps" className="scroll-mt-28 space-y-3">
      <h2 className="font-display text-xl font-semibold tracking-tight">Step by step</h2>
      {blocks.map((b, i) => b.allowed ? (
        <div key={i} data-testid={`kc-steps-allowed-${i}`} className="tile overflow-hidden border-success/30">
          <div className="px-4 py-2.5 border-b border-border bg-success/[0.06] flex flex-wrap items-center justify-between gap-2">
            <span className="text-[13.5px] font-semibold">{b.title}</span>
            <span className="inline-flex items-center gap-1 text-[10.5px] uppercase tracking-widest font-semibold text-success"><ShieldCheck size={11} /> For {b.roles_label}</span>
          </div>
          <ol className="px-4 py-3 space-y-2 list-none">
            {b.items.map((s, j) => (
              <li key={j} className="flex gap-3 text-[13.5px] leading-relaxed">
                <span className="w-5 h-5 mt-0.5 shrink-0 rounded-sm bg-success/15 text-success font-mono-tabular text-[10.5px] font-semibold flex items-center justify-center">{j + 1}</span>
                <Rich text={s} />
              </li>
            ))}
          </ol>
        </div>
      ) : (
        <div key={i} data-testid={`kc-steps-restricted-${i}`} className="tile px-4 py-3 flex items-start gap-3 border-dashed">
          <Lock size={14} className="text-warning mt-0.5 shrink-0" />
          <div>
            <div className="text-[13.5px] font-semibold">{b.title}</div>
            <div data-testid={`kc-steps-restricted-note-${i}`} className="text-[12.5px] text-muted mt-0.5">{b.note}. The overview, concepts and example above apply to everyone.</div>
          </div>
        </div>
      ))}
    </section>
  );
}
